<div class="w-100">
  <div class="card card-block card-stretch mb-0">
    <div class="card-header d-flex justify-content-between">
      <a [routerLink]="['/shopee']" class="header-title text-decoration-none text-reset">
        <h4 class="card-title fw-bold">Shopee nào bro!!!</h4>
      </a>
    </div>
  </div>
</div>
<div *ngIf="isMobile()">
  <div class="w-100">
    <div class="card card-block card-stretch mb-0">
      <div class="card-header">
        <div class="w-100">
          <!-- Browser + loaded only: owl-carousel-o measures 0 width during SSR and ships slides
               with no item width, which render stacked vertically on mobile. Creating it in the
               browser with the final slide set lets owl measure the real width and lay out
               horizontally. A static skeleton row holds the space until then (avoids CLS). -->
          <owl-carousel-o [options]="customOptions" *ngIf="isBrowser && loaded && listShopee.length; else shopeeCarouselSkeletonRow">
            <ng-container *ngFor="let slide of listShopee; let i = index">
              <ng-template carouselSlide>
                <a [href]="slide.link" target="_blank" rel="noopener noreferrer" [title]="slide.name" *ngIf="!slide.is_lazy; else shopeeSkeletonCarousel" class="shopee-hot-card">
                  <div class="image-container w-100">
                    <!-- First slide is above the fold on mobile (it's the actual LCP element per
                         Lighthouse) — lazy-loading it added ~2.4s of avoidable "Load Delay" to LCP. -->
                    <!-- alt="" — the product name is already shown as visible text below
                         (.shopee-hot-name), so a matching alt was flagged as redundant. -->
                    <img [attr.loading]="i === 0 ? null : 'lazy'" [attr.fetchpriority]="i === 0 ? 'high' : null"
                         [src]="apiUrl + '/' + (slide.image_thumb || slide.image)" alt="" [title]="slide.name"
                         class="img-fluid rounded w-100">
                    <div class="overlay"></div>
                  </div>
                  <div class="shopee-hot-info">
                    <div class="shopee-hot-name">{{slide.name}}</div>
                    <div class="shopee-hot-price" *ngIf="slide.price">{{slide.price}}</div>
                    <div class="shopee-hot-shop" *ngIf="slide.shop_name">{{slide.shop_name}}</div>
                  </div>
                </a>
              </ng-template>
            </ng-container>
          </owl-carousel-o>
          <ng-template #shopeeCarouselSkeletonRow>
            <div class="d-flex" style="gap: 8px;">
              <div class="skel" style="flex: 1; aspect-ratio: 1 / 1; border-radius: 8px;"></div>
              <div class="skel" style="flex: 1; aspect-ratio: 1 / 1; border-radius: 8px;"></div>
              <div class="skel" style="flex: 1; aspect-ratio: 1 / 1; border-radius: 8px;"></div>
            </div>
          </ng-template>
        </div>
      </div>
    </div>
  </div>
</div>
<div *ngIf="!isMobile()">
  <div class="w-100" *ngFor="let item of listShopee; let i = index">
    <a [href]="item.link" target="_blank" rel="noopener noreferrer" [title]="item.name" *ngIf="!item.is_lazy; else shopeeSkeleton" class="shopee-hot-card">
      <div class="card card-block card-stretch mb-0">
        <div class="card-header">
          <div class="image-container w-100">
            <!-- alt="" — the product name is already shown as visible text below (.shopee-hot-name),
                 so a matching alt was flagged as redundant. -->
            <img [attr.loading]="i === 0 ? null : 'lazy'" [attr.fetchpriority]="i === 0 ? 'high' : null"
                 [src]="apiUrl + '/' + (item.image_thumb || item.image)" alt="" [title]="item.name"
                 class="img-fluid rounded w-100">
            <div class="overlay"></div>
          </div>
          <div class="shopee-hot-info">
            <div class="shopee-hot-name">{{item.name}}</div>
            <div class="shopee-hot-price" *ngIf="item.price">{{item.price}}</div>
            <div class="shopee-hot-shop" *ngIf="item.shop_name">{{item.shop_name}}</div>
          </div>
        </div>
      </div>
    </a>
  </div>
</div>
<ng-template #shopeeSkeleton>
  <div class="card card-block card-stretch mb-0">
    <div class="card-header">
      <div class="skel" style="height: 180px; border-radius: 8px;"></div>
      <div class="skel" style="height: 14px; width: 90%; margin-top: 8px;"></div>
      <div class="skel" style="height: 14px; width: 50%; margin-top: 6px;"></div>
    </div>
  </div>
</ng-template>
<ng-template #shopeeSkeletonCarousel>
  <div class="card card-block card-stretch mb-0">
    <div class="card-header">
      <div class="skel" style="height: 100px; border-radius: 8px;"></div>
    </div>
  </div>
</ng-template>
